module.exports = __webpack_public_path__ + "static/media/msl_tactical_plus_demo.36b303ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_tactical_plus_demo.jpg
// module id = 85
// module chunks = 0